import { Ring } from "@uiball/loaders";
import classNames from "classnames";
import { useEffect, useState } from "react";

function MainLoading() {
  const [fadeIn, setFadeIn] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    setFadeIn(true);
    setFadeOut(false);

    return () => {
      setFadeIn(false);
      setFadeOut(true);
    };
  }, []);

  return (
    <div
      className={classNames("main-loading-container", {
        animate__animated: true,
        animate__fadeIn: fadeIn,
        animate__fadeOut: fadeOut,
      })}
    >
      <Ring size={150} lineWeight={5} speed={2} color="#777e8b" />
    </div>
  );
}

export default MainLoading;
